import _ from 'lodash';
import UserRoles, { UserRole } from '../enums/userRoles';

export const generateStringSorter = (fieldPath: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (a: any, b: any) => {
    const aVal = _.get(a, fieldPath) || '';
    const bVal = _.get(b, fieldPath) || '';
    return aVal.localeCompare(bVal);
  };
};

export const quantitizeRole = (role?: UserRole) => {
  if (role === UserRoles.MEMBER) return 1;
  if (role === UserRoles.ADMIN) return 2;
  if (role === UserRoles.OWNER) return 3;
  return 0;
};
export const sortUserRole = (a: UserRole, b: UserRole) => {
  return quantitizeRole(a) - quantitizeRole(b);
};
